import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';

/**
 * Signed in, but a member of no team.
 *
 * Every new account starts here: sign-up (email or Google) yields a session
 * whose only account is the personal one, and the console does not operate
 * on personal accounts. Membership is granted by an invitation, so the only
 * thing to say is who to ask.
 */
export function NoWorkspace() {
  const { session, signOut } = useAuth();

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-4 text-center">
        <h1 className="text-xl font-semibold tracking-tight">No workspace yet</h1>
        <p className="text-muted-foreground text-sm">
          <span className="font-medium">{session?.user.email}</span> is not a member of any
          dispensary. Ask an owner to invite you, then open the link they send.
        </p>
        <Button variant="outline" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
